module.exports = __webpack_public_path__ + "media/images/media/images/pic/teachers/magdalena-kisly-cc0ffe90eedb0b2946f5b7036aa2a124.webp";